export const isNullish = (value: any): value is null | undefined => {
  return value === null || typeof value === 'undefined'
}

export const isNotNullish = <T>(value: T): value is NonNullable<T> => {
  return !isNullish(value)
}

export const isInvalidDate = (date: Date): boolean => {
  return Number.isNaN(date.getTime())
}